import { GetOnboardingProcessDocument } from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

import { useMaterializedProcess } from 'modules/processes/hooks/materializedProcess/useMaterializedProcess'

export const useGetOnboardingProcess = () => {
  const [fetchOnboardingProcess, { data, loading: loadingOnboarding, error }] = useLazyQuery(
    GetOnboardingProcessDocument
  )

  const materializedProcessId =
    data?.employeeOnboarding.employeeOnboardingsConnection.edges.at(0)?.node
      ?.materializedProcessId || 0

  const { materializedProcess, loading: loadingMaterializedProcess } = useMaterializedProcess({
    id: materializedProcessId,
  })

  const loading = loadingOnboarding || loadingMaterializedProcess

  return {
    fetchOnboardingProcess,
    loading,
    error,
    materializedSteps: materializedProcess?.materializedSteps || [],
    process: materializedProcess?.process,
    materializedProcess,
  }
}
